export class Team {
  groupId?: number;
  projectId?: number;
  taskId?: number;
  name: string;
}